
import React from 'react';
import BarChart from 'CommonComponents/BarChart';
import { msToTime, getDisplayFullDateShort, pad2, msToTime2, msToTimeForStatCardDuration } from './DateHelper';
import {
  durationStatcardMapping,
  getAHFEventTypeColor,
  getDMSEventTypeColor,
  getDomtarEventTypeColor,
  getGEEventTypeColor,
  getManufacturingEventTypeColor,
  IncidentTypesAHF,
  IncidentTypesGE,
  IncidentTypesManufacturing
} from './Constants';
import { Avatar } from '@mui/material';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import store from 'storage';

export const getAllIncidents = (applicationConfig) => {
  if (applicationConfig === "DashboardManufacturingBundleGEAppliances") {
    return IncidentTypesGE;
  } else if (applicationConfig === "DashboardManufacturingBundleAHF") {
    return IncidentTypesAHF;
  } else { // This else must go at the end
    return IncidentTypesManufacturing;
  }
}

const { getFormattedDate } = require("./DateHelper")

export const getExportFileName = (searchStartDate, searchEndDate) => {
  return `DoriAIVisionReport_${getFormattedDate(new Date(searchStartDate))}_${getFormattedDate(new Date(searchEndDate))}`
}

export const CYCLE_TIME_THRESHOLD = 0.2;

export const MonthTypes = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

function generateDateFormat2(currDate) {
  let getYear = new Date(currDate).getFullYear();
  let getMonths = new Date(currDate).getMonth() + 1;
  let getDate = new Date(currDate).getDate();
  return pad2(getYear) + "-" + pad2(getMonths) + "-" + pad2(getDate);
}

export const defaultDetectedByHour = [
  {
    Time: "00 hrs",
    count: 0,
  },
  {
    Time: "01 hrs",
    count: 0,
  },
  {
    Time: "02 hrs",
    count: 0,
  },
  {
    Time: "03 hrs",
    count: 0,
  },
  {
    Time: "04 hrs",
    count: 0,
  },
  {
    Time: "05 hrs",
    count: 0,
  },
  {
    Time: "06 hrs",
    count: 0,
  },
  {
    Time: "07 hrs",
    count: 0,
  },
  {
    Time: "08 hrs",
    count: 0,
  },
  {
    Time: "09 hrs",
    count: 0,
  },
  {
    Time: "10 hrs",
    count: 0,
  },
  {
    Time: "11 hrs",
    count: 0,
  },
  {
    Time: "12 hrs",
    count: 0,
  },
  {
    Time: "13 hrs",
    count: 0,
  },
  {
    Time: "14 hrs",
    count: 0,
  },
  {
    Time: "15 hrs",
    count: 0,
  },
  {
    Time: "16 hrs",
    count: 0,
  },
  {
    Time: "17 hrs",
    count: 0,
  },
  {
    Time: "18 hrs",
    count: 0,
  },
  {
    Time: "19 hrs",
    count: 0,
  },
  {
    Time: "20 hrs",
    count: 0,
  },
  {
    Time: "21 hrs",
    count: 0,
  },
  {
    Time: "22 hrs",
    count: 0,
  },
  {
    Time: "23 hrs",
    count: 0,
  },
];

export function handleEntriesByHour(data, type) {
  let tempData =
    data && data.length !== 0
      ? data.map((item) => {
        let newDate = new Date(item.incidentTime);
        let hour = newDate.getHours();
        let dateByHour = (hour < 10 ? "0" : "") + hour + " hrs";
        return {
          Time: dateByHour,
        };
      })
      : [];
  // console.log(tempData);
  let tempData2 =
    tempData && tempData !== []
      ? [
        ...tempData
          .reduce((r, e) => {
            let k = e.Time;
            if (!r.has(k)) r.set(k, { ...e, entriesCount: 1 });
            else r.get(k).entriesCount++;
            return r;
          }, new Map())
          .values(),
      ]
      : [];
  // entries by hour calculations
  // console.log(tempData2, exitsData, "entries and exitsData");
  let tempDataByHour =
    tempData2 && tempData2.length !== 0
      ? tempData2.map((item) => ({
        Time: item.Time,
        count: item.entriesCount,
      }))
      : [];

  // merging the entries by hour and default hour data and sorting
  let mergedHourCountEntries = [...tempDataByHour, ...defaultDetectedByHour];

  // merging by Time property
  let set = new Set();
  let unionArrayEntries = mergedHourCountEntries.filter((item) => {
    if (!set.has(item.Time)) {
      set.add(item.Time);
      return true;
    }
    return false;
  }, set);
  // console.log(unionArrayEntries, "union array");
  // sorting based on Time property
  // console.log("unionArrayEntries", unionArrayEntries);
  let unionArrayEntries2 = unionArrayEntries.map((item) => ({
    Time: pad2(parseInt(item.Time.split(" ")[0])),
    count: parseInt(item.count),
  }));
  const tempSortedArr =
    unionArrayEntries2 !== []
      ? unionArrayEntries2.sort((a, b) => a.Time - b.Time)
      : [];
  const sortedArr =
    tempSortedArr !== []
      ? tempSortedArr.map((item) => ({
        Time: `${item.Time} hrs`,
        [`${type}`]: item.count === "" ? 0 : item.count,
      }))
      : [];
  // .map(Object.values);
  return sortedArr;
}

export function handleEntriesByDates(data, type, defaultDataByMonth) {
  let tempData =
    data && data.length !== 0
      ? data.map((item) => {
        let dateByMonth = generateDateFormat2(item.incidentTime);
        return {
          Time: dateByMonth,
        };
      })
      : [];
  // console.log(tempData);
  let tempData2 =
    tempData && tempData.length !== 0
      ? [
        ...tempData
          .reduce((r, e) => {
            let k = e.Time;
            if (!r.has(k)) r.set(k, { ...e, entriesCount: 1 });
            else r.get(k).entriesCount++;
            return r;
          }, new Map())
          .values(),
      ]
      : [];
  // entries by hour calculations
  // console.log(tempData2, exitsData, "entries and exitsData");
  let tempDataByHour =
    tempData2 &&
    tempData2.map((item) => ({
      Time: item.Time,
      count: item.entriesCount,
    }));

  // merging the entries by hour and default hour data and sorting
  let mergedHourCountEntries = [...tempDataByHour, ...defaultDataByMonth];

  // merging by Time property
  let set = new Set();
  let unionArrayEntries = mergedHourCountEntries.filter((item) => {
    if (!set.has(item.Time)) {
      set.add(item.Time);
      return true;
    }
    return false;
  }, set);
  // console.log(unionArrayEntries, "union array");
  // sorting based on Time property

  let unionArrayEntries2 = unionArrayEntries.map((item) => ({
    // Time: pad2(item.Time.split(" ")[1]),
    // month: item.Time.split(" ")[0],
    Time: item.Time,
    count: parseInt(item.count),
  }));
  const tempSortedArr =
    unionArrayEntries2 !== [] &&
    unionArrayEntries2.sort((a, b) => a.Time - b.Time);
  const sortedArr =
    tempSortedArr !== [] &&
    tempSortedArr.map((item) => ({
      // Time: `${item.month} ${item.Time}`,
      Time: item.Time,
      [`${type}`]: item.count === "" ? 0 : item.count,
    }));
  // .map(Object.values);
  // console.log(sortedArr)
  let formattedArr = (sortedArr || []).map((i) => {
    let year = i.Time.split("-")[0];
    let month = parseInt(i.Time.split("-")[1]);
    let tempDate = i.Time.split("-")[2];
    let dateByMonth = MonthTypes[month - 1] + "/" + tempDate;
    return {
      ...i,
      Time: dateByMonth,
    };
  });
  // console.log(formattedArr)
  return formattedArr;
}

export const getHourlyCycleTimeBucketData = (dataDisplay) => {
  const hourBucket = {
    '00': { value: 0, count: 0 },
    '01': { value: 0, count: 0 },
    '02': { value: 0, count: 0 },
    '03': { value: 0, count: 0 },
    '04': { value: 0, count: 0 },
    '05': { value: 0, count: 0 },
    '06': { value: 0, count: 0 },
    '07': { value: 0, count: 0 },
    '08': { value: 0, count: 0 },
    '09': { value: 0, count: 0 },
    '10': { value: 0, count: 0 },
    '11': { value: 0, count: 0 },
    '12': { value: 0, count: 0 },
    '13': { value: 0, count: 0 },
    '14': { value: 0, count: 0 },
    '15': { value: 0, count: 0 },
    '16': { value: 0, count: 0 },
    '17': { value: 0, count: 0 },
    '18': { value: 0, count: 0 },
    '19': { value: 0, count: 0 },
    '20': { value: 0, count: 0 },
    '21': { value: 0, count: 0 },
    '22': { value: 0, count: 0 },
    '23': { value: 0, count: 0 },
  };
  dataDisplay.forEach((data) => {
    if (data.startTime !== "-") {
      const startTime = new Date(data.startTime).getHours();
      const startTimeStr = startTime < 10 ? `0${startTime}` : `${startTime}`;
      const tempCycleTimeArr = data.cycleTime.split(":");
      hourBucket[startTimeStr].value += parseInt(tempCycleTimeArr[0]) * 60 + parseInt(tempCycleTimeArr[1]);
      hourBucket[startTimeStr].count += 1;
    }
  });

  const bucketData = [['Hour', '', { role: 'style' }, { role: 'annotation' }]]
  Object.keys(hourBucket).sort((a, b) => parseInt(a) - parseInt(b)).forEach((hour) =>
    bucketData.push([
      `${hour} : 00`,
      hourBucket[hour].count ? hourBucket[hour].value / hourBucket[hour].count : hourBucket[hour].value,
      '#5e82e5',
      hourBucket[hour].count ? hourBucket[hour].value / hourBucket[hour].count : hourBucket[hour].value,
    ]));
  return bucketData;
}

export const getDailyCycleTimeChartData = (wholeData, SOPStart) => {
  const bucketData = [['Date', '', { role: 'style' }, { role: 'annotation' }]];
  if (wholeData.length) {
    let dailyBucket = {};
    wholeData.forEach((data) => {
      if (data.incidentType === SOPStart) {
        const day = data.incidentDate.split(' ')[1] + ' ' + data.incidentDate.split(' ')[2];
        if (Object.keys(dailyBucket).includes(day)) {
          dailyBucket[day] += 1;
        } else {
          dailyBucket[day] = 1;
        }
      }
    });

    Object.keys(dailyBucket).forEach((dayKey) => {
      bucketData.push([
        dayKey,
        dailyBucket[dayKey],
        '#5e82e5',
        dailyBucket[dayKey],
      ])
    })

    return bucketData;
  }

  return [["Date", "Events"], ["No Events Found", 0]];

}

const getCycleTimeColor = (cycleTime, avgCycleTime) => {
  const timeArr = avgCycleTime.split(":");
  const cycleTimeAvg = (parseInt(timeArr[0]) * 60 * 60) + (parseInt(timeArr[1]) * 60) + parseInt(timeArr[2]);

  //console.log(cycleTime, avgCycleTime, cycleTimeAvg)

  // Cycle time color should be > 50% away from average to be considered an anomaly
  if (cycleTime > cycleTimeAvg + cycleTimeAvg * CYCLE_TIME_THRESHOLD || cycleTime < cycleTimeAvg - cycleTimeAvg * CYCLE_TIME_THRESHOLD) { return "#e57373" }
  else { return "#70a9a1" }
};

export const generateCycleTimeChartData = (dataDisplay, showFailedOnly) => {
  let tempCycleTimeData = [];

  const tempDataDisplay = showFailedOnly
    ? dataDisplay.filter(f => !f.compliance.isComplete)
    : [...dataDisplay]

  // console.log(dataDisplay);
  if (tempDataDisplay.length) {
    tempDataDisplay.forEach((data, index) => {
      const timeArr = data.cycleTime.split(":");
      const cycleTimeSeconds = (parseInt(timeArr[0]) * 60 * 60) + (parseInt(timeArr[1]) * 60) + parseInt(timeArr[2]);
      // const getAvgCycleTimeStr = msToTime2(avgCycleTime);
      tempCycleTimeData.push([
        tempDataDisplay.length - index,
        cycleTimeSeconds,
        data.compliance.isComplete ? '#70a9a1' : '#e57373',
        `<div style="padding: 5px; white-space: nowrap">
          <div><span style="color: black">Unit #: </span> ${tempDataDisplay.length - index}</div>
          <div><span style="color: black">Cycle Start Time: </span> ${data.startTime}</div>
          <div><span style="color: black">Cycle End Time: </span> ${data.endTime}</div>
          <div><span style="color: black">Cycle Time: </span> 
           ${Math.round(data.compliance.cycleTime / 1000)} seconds (${data.cycleTime})</div>
        </div>`

      ])
    });
  }
  tempCycleTimeData.push([
    { type: "string", label: "Unit" },
    { type: "number", label: "Cycle Time" },
    { role: "style" },
    { role: "tooltip", type: "string", p: { html: true } }
  ]);
  tempCycleTimeData.reverse();
  return tempCycleTimeData;
}

export const getMinCycleTime = (dataDisplay) => {
  const timeArr = dataDisplay.map((data) => {
    if (data.startTime && data.endTime) {
      return new Date(data.endTime).getTime() - new Date(data.startTime).getTime()
    } else {
      return 0;
    }
  });
  const minIndex = timeArr.indexOf(Math.min(...timeArr));
  console.log('min index: ', minIndex);
  if (minIndex === -1) {
    return '00:00:00'
  }

  if (dataDisplay.length) {
    return dataDisplay[minIndex].cycleTime;
  }
  return '00:00:00'
}

export const getMaxCycleTime = (dataDisplay) => {
  const timeArr = dataDisplay.map((data) => {
    if (data.startTime && data.endTime) {
      return new Date(data.endTime).getTime() - new Date(data.startTime).getTime()
    } else {
      return 0;
    }
  });
  const maxIndex = timeArr.indexOf(Math.max(...timeArr));
  if (maxIndex === -1) {
    return '00:00:00'
  }

  if (dataDisplay.length) {
    return dataDisplay[maxIndex].cycleTime;
  }
  return '00:00:00'
}

export const getAvgCycleTime = (dataDisplay) => {
  let hour = 0;
  let minute = 0;
  let second = 0;

  dataDisplay.forEach((data) => {
    if (data.cycleTime) {
      const cycleTimeArr = data.cycleTime.split(':');
      hour += parseInt(cycleTimeArr[0]);
      minute += parseInt(cycleTimeArr[1]);
      second += parseInt(cycleTimeArr[2]);
    }
  });
  hour /= dataDisplay.length; hour = parseInt(hour);
  minute /= dataDisplay.length; minute = parseInt(minute);
  second /= dataDisplay.length; second = parseInt(second);
  if (hour < 10) { hour = '0' + hour.toString() }
  if (minute < 10) { minute = '0' + minute.toString() }
  if (second < 10) { second = '0' + second.toString() }

  if (!hour || !minute || !second) {
    return '00:00:00'
  }
  //console.log(`${hour}:${minute}:${second}`)
  return `${hour}:${minute}:${second}`;
}

export const getAvgCycleTimeValue = (dataDisplay) => {
  let hour = 0;
  let minute = 0;
  let second = 0;

  dataDisplay.forEach((data) => {
    if (data.cycleTime) {
      const cycleTimeArr = data.cycleTime.split(':');
      hour += parseInt(cycleTimeArr[0]);
      minute += parseInt(cycleTimeArr[1]);
      second += parseInt(cycleTimeArr[2]);
    }
  });
  hour /= dataDisplay.length; hour = parseInt(hour);
  minute /= dataDisplay.length; minute = parseInt(minute);
  second /= dataDisplay.length; second = parseInt(second);
  if (hour < 10) { hour = '0' + hour.toString() }
  if (minute < 10) { minute = '0' + minute.toString() }
  if (second < 10) { second = '0' + second.toString() }

  return [hour, minute, second];
}

export const getNumberOfCycleTimeViolations = (dataDisplay) => {
  const avgCycleTimeArr = getAvgCycleTime().split(':');
  const avgCycleTime = parseInt(avgCycleTimeArr[0]) * 3600 + parseInt(avgCycleTimeArr[1]) * 60 + parseInt(avgCycleTimeArr[2]);
  const maxTwenty = avgCycleTime + avgCycleTime * 0.2;
  const minTwenty = avgCycleTime - avgCycleTime * 0.2;
  let violations = 0;

  dataDisplay.forEach((data) => {
    const cycleTimeArr = data.cycleTime.split(':');
    const cycleTime = parseInt(cycleTimeArr[0]) * 3600 + parseInt(cycleTimeArr[1]) * 60 + parseInt(cycleTimeArr[2]);
    if (cycleTime > maxTwenty || cycleTime < minTwenty) {
      violations += 1;
    }
  })

  return violations;

}

export const getAvgStepCycleTime = (dataDisplay, selectedStepIndex) => {
  let tempStepCycleTime = 0;
  for (let j = 1; j < dataDisplay.length; j++) {
    tempStepCycleTime += dataDisplay[j].compliance.steps[selectedStepIndex].cycleTime || 0;
  }
  if (dataDisplay.length) {
    return msToTime(parseInt(tempStepCycleTime / dataDisplay.length));
  }
  return 'N/A'
};

export const isSameDay = (date1, date2) => {
  if (
    getDisplayFullDateShort(new Date(date1)).split(' ')[0] ===
    getDisplayFullDateShort(new Date(date2)).split(' ')[0]
  ) {
    return true;
  }
  return false;
}

export const getCameraName = (cameraId, allCameras) => {
  const camObj = allCameras.find((cam) => cam.id === cameraId);
  if (camObj) {
    return camObj.name;
  }
  return 'Cam not found';
}

export const getLocationName = (locationId, allLocations) => {
  const locObj = allLocations.find(loc => loc.id === locationId);
  if (locObj) {
    return `${locObj.displayLayer1}/${locObj.displayLayer2}/${locObj.site}`;
  }
  return 'Location not found';
}

export const getDatagridData = (data, cameraData, locationsData) => {
  data.sort((a, b) => b.incidentTime - a.incidentTime);
  return data.map((d, index) => {
    return ({
      id: index,
      thumbnail: d.thumbnail,
      video: d.video,
      type: d.incidentType,
      camera: getCameraName(d.cameraId, cameraData),
      location: getLocationName(d.locationId, locationsData),
      time: getDisplayFullDateShort(new Date(d.incidentTime))
    });
  })
}

export const generateBarChart = (
  onClickCallback,
  chartData,
  value = 'Allday',
  colors = {}
) => {
  // console.log('colors 1: ', colors, value);
  let barChartDisplay;
  if (value === "customPeriod") {
    barChartDisplay = (
      <div >
        <BarChart
          colors={colors}
          chartEvents={onClickCallback}
          chartType={"ColumnChart"}
          barChartData={chartData}
          title=""
          // width={"100%"}
          height={"100%"}
          isStacked={true}
          options={{
            legend: { position: "none" },
          }}
        />
      </div>
    );
  } else {
    barChartDisplay = (
      <div >
        <BarChart
          colors={colors}
          chartEvents={onClickCallback}
          chartType={"ColumnChart"}
          barChartData={chartData}
          title=""
          width={"100%"}
          height={"100%"}
          isStacked={true}
          options={{
            legend: { position: "none" },
          }}
        />
      </div>
    );
  }
  return barChartDisplay;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const filterData = (data, type) => {
  return (data || []).filter((i) => i.incidentType === type);
};

function getDateList(startDate, endDate) {
  const listDate = [];
  const dateMove = new Date(startDate);
  let strDate = startDate;

  strDate = dateMove.toISOString().slice(0, 10);
  while (strDate <= endDate) {
    let obj = {
      Time: strDate,
      count: 0,
    };
    listDate.push(obj);
    dateMove.setDate(dateMove.getDate() + 1);
    strDate = dateMove.toISOString().slice(0, 10);
  }
  return listDate;
}

export const generateIncidentTypeData = (
  data,
  allIncidentTypes,
  value,
  searchStartDate,
  searchEndDate) => {
  let incidentTypes = [...allIncidentTypes];
  var tempfinalData = [];
  for (let i = 0; i < incidentTypes.length; i++) {
    let incidentName = capitalizeFirstLetter(
      incidentTypes[i].replaceAll(/\s/g, "")
    );
    let tempdata = [];
    if (value === "allday") {
      tempdata = handleEntriesByHour(
        filterData(data, incidentTypes[i]),
        incidentName,
        getDateList(searchStartDate, searchEndDate)
      );
    } else if (value === "customPeriod") {
      tempdata = handleEntriesByDates(
        filterData(data, incidentTypes[i]),
        incidentName,
        getDateList(searchStartDate, searchEndDate)
      );
    }
    tempfinalData.push(tempdata);
  }
  let finalData2 = tempfinalData.flat(1);

  const noDuplicate = (arr) => [...new Set(arr)];

  const allIds = finalData2.map((ele) => ele.Time);
  const ids = noDuplicate(allIds);

  const result = ids.map((Time) =>
    finalData2.reduce((self, item) => {
      return item.Time === Time ? { ...self, ...item } : self;
    }, {})
  );
  if (value === "allday") {
    return (result || []).sort((a, b) =>
      a.Time.localeCompare(b.Time)
    );
  }
  const result1 = [];
  result.forEach((obj) => {
    let tempObj = {};
    ['Time', ...allIncidentTypes].forEach((incident) => {
      let incidentName = capitalizeFirstLetter(
        incident.replaceAll(/\s/g, "")
      );
      if (obj[incidentName]) {
        tempObj[incidentName] = obj[incidentName];
      } else {
        tempObj[incidentName] = 0;
      }
    });
    result1.push(tempObj)
  });
  let sortedData = (result1 || []).sort((a, b) =>
    a.Time.localeCompare(b.Time)
  );
  return sortedData;
};


export const getAvgPerHour = (date1, date2, data) => {
  if (!data.length) {
    return 'N/A'
  }
  if (isSameDay(date1, date2)) {
    return (data.length / 24).toFixed(2);
  }
  return (data.length / ((Math.abs(new Date(date1).getTime() - new Date(date2).getTime())) / (1000 * 60 * 60))).toFixed(2);
}

export const getStepStatus = (step) => {
  if (!step) {
    return 'optional';
  }
  if (step.isViolation && step.isComplete) {
    return 'warning';
  }
  if (step.isViolation && !step.isComplete) {
    return 'no_warning';
  }
  if (step.isRequired && !step.isComplete) {
    return 'error';
  };
  if (step.isRequired && step.isComplete) {
    return 'success';
  };
  if (step.isComplete) {
    return 'success';
  };
  if (!step.isRequired && !step.isComplete) {
    return 'optional';
  };
  return 'optional';
}

export const getStepTitle = (step) => {
  const tempStatus = getStepStatus(step);
  if (tempStatus === 'success') {
    return 'Step Detected'
  } else if (tempStatus === 'no_warning') {
    return 'Violation Not Detected'
  } else if (tempStatus === 'warning') {
    return 'Violation Detected'
  } else if (tempStatus === 'error') {
    return 'Step Not Detected'
  } else if (tempStatus === 'optional') {
    return 'Step Optional'
  }
}

export const reorderArrayByTimeKey = (data) => {
  let finalData = [];
  for (const [key, value] of Object.entries(data)) {
    if (key === "Time") {
      finalData.push(value)
    }
  }
  for (const [key, value] of Object.entries(data)) {
    if (key !== "Time") {
      finalData.push(value)
    }
  }
  //  console.log("finalData", finalData);
  return finalData;
}

const barChartEvents = [
  {
    eventName: "select",
    callback({ chartWrapper }) {
      // setBarChartSelection(chartWrapper.getChart().getSelection());
      //console.log('bar chart event: ', chartWrapper.getChart().getSelection())
    }
  }
];

export const getStackedBarChartColor = (allIncidentTypes) => {
  const allColors = {
    'Passed': '#17B696',
    'Failed': '#b71c1c',
    'Overridden': '#FFAB40'
  }

  let incidentColors = {};

  allIncidentTypes.forEach((incident, index) => {
    incidentColors[index] = { color: allColors[incident] }
  })

  return incidentColors;
}

export const getEventTypeColor = (incidentType, applicationConfig) => {
  if (applicationConfig === "DashboardManufacturingBundleGEAppliances") {
    return getGEEventTypeColor(incidentType)
  } else if (applicationConfig === "DashboardManufacturingBundleAHF") {
    return getAHFEventTypeColor(incidentType)
  } else if (applicationConfig === "DashboardManufacturingBundleDMS-Safety") {
    return getDMSEventTypeColor(incidentType);
  } else if (applicationConfig === "DashboardManufacturingBundleDomtar-Gantry") {
    return getDomtarEventTypeColor(incidentType);
  }
  return getManufacturingEventTypeColor(incidentType);
}

export const generateBarChartData = (
  wholeData,
  barChartEvents,
  searchStartDate,
  searchEndDate,
  applicationConfig
) => {
  let barChartData = {
    chartData: [],
    chartColors: null
  }
  let tempWholeDataBarChart = [...wholeData];
  tempWholeDataBarChart = tempWholeDataBarChart.filter((data) => barChartEvents.includes(data.incidentType));
  let tempIncidentTypes = [...new Set(tempWholeDataBarChart.map(data => data.incidentType))];
  let allIncidentTypes = barChartEvents && barChartEvents.length && tempIncidentTypes.length
    ? barChartEvents
    : tempIncidentTypes;
  if (isSameDay(searchStartDate, searchEndDate)) {
    let chartData2 = [];
    if (tempWholeDataBarChart && tempWholeDataBarChart.length !== 0) {
      chartData2 = JSON.parse(JSON.stringify(defaultDetectedByHour));
      chartData2 = generateIncidentTypeData(
        tempWholeDataBarChart,
        allIncidentTypes,
        'allday',
        searchStartDate,
        searchEndDate);
    } else {
      chartData2 = [];
    }
    let finalData =
      chartData2 && chartData2.length !== 0
        ? chartData2.map(i => reorderArrayByTimeKey(i))
        : [];
    if (allIncidentTypes.length) {
      finalData.unshift(['Hour', ...allIncidentTypes]);
    }
    barChartData.chartData = finalData;
    const tempBarchartColors = [];
    if (finalData.length) {
      finalData[0].slice(1).forEach(event => {
        if (getEventTypeColor(event, applicationConfig)) {
          tempBarchartColors.push(getEventTypeColor(event, applicationConfig));
        }
      });
      if (tempBarchartColors.length) {
        barChartData.chartColors = tempBarchartColors;
      }
    }
  } else {
    let chartData = [];
    if (tempWholeDataBarChart && tempWholeDataBarChart.length !== 0) {
      chartData = generateIncidentTypeData(
        tempWholeDataBarChart,
        allIncidentTypes,
        'customPeriod',
        searchStartDate,
        searchEndDate
      );
    } else {
      chartData = [];
    }

    let finalData =
      chartData && chartData.length !== 0
        ? chartData.map(i => reorderArrayByTimeKey(i))
        : [];
    if (allIncidentTypes.length) {
      finalData.unshift(['Date', ...allIncidentTypes]);
    }
    barChartData.chartData = finalData;
    const tempBarchartColors = [];
    if (finalData.length) {
      finalData[0].slice(1).forEach(event => {
        if (getEventTypeColor(event, applicationConfig)) {
          tempBarchartColors.push(getEventTypeColor(event, applicationConfig));
        }
      });
      if (tempBarchartColors.length) {
        barChartData.chartColors = tempBarchartColors;
      }
    }
  }
  return barChartData;
}

const cardStyleStat = { padding: "4px 8px", boxShadow: "none", height: "180px", fontWeight: '100' };
let displayAvatar = (bgcolor, icon) => {
  return (
    <Avatar sx={{ bgcolor: bgcolor }} aria-label="recipe">
      {icon}
    </Avatar>
  );
}

export const calculateTotalIncidentCounts = (data) => {
  // Set up distinct incident types
  var tempTotalIncidentCountsTypes = [...new Set(data.map(item => item.incidentType))];
  let tempTotalIncidentCounts = tempTotalIncidentCountsTypes.map(item => {
    return {
      incidentTypes: item,
      incidentCount: data.filter(event => event.incidentType === item).length,
    }
  })

  return tempTotalIncidentCounts;
}

export const calculateTotalIncidentDuration = (data) => {
  // Set up distinct incident types
  var tempTotalIncidentCountsTypes = [...new Set(data.map(item => item.incidentType))];
  let tempTotalIncidentDurations = tempTotalIncidentCountsTypes.map(item => {
    return {
      incidentTypes: item,
      incidentCount: msToTimeForStatCardDuration(data.filter(event => event.incidentType === item)
        .reduce((acc, obj) => { return (acc + obj.incidentData.duration) }, 0)),
    }
  })

  return tempTotalIncidentDurations;
}

export const generateStatCardData = (
  wholeData,
  statCardsDurationEvents,
  statCardsCountEvents,
  applicationConfig
) => {
  if (!wholeData.length) {
    let useCasesCount = statCardsCountEvents.map((useCase, index) => {
      return {
        title: useCase,
        body: '0',
        footer: "Total",
        cardStyle: cardStyleStat,
        avatar: displayAvatar(getEventTypeColor(useCase, applicationConfig),
          <CenterFocusStrongIcon />),
      }
    })

    let useCasesDuration = statCardsDurationEvents.map((useCase, index) => {
      return {
        title: durationStatcardMapping[useCase] || useCase,
        body: "00:00:00",
        footer: "Total Duration",
        cardStyle: cardStyleStat,
        avatar: displayAvatar(getEventTypeColor(useCase, applicationConfig),
          <CenterFocusStrongIcon />),
      }
    });

    const extraStatCard = [];
    if (applicationConfig === 'DashboardManufacturingBundleDMS-Safety' ||
      applicationConfig === 'DashboardManufacturingBundleDomtar-Gantry') {
      extraStatCard.push({
        title: 'Total Events',
        body: '0',
        footer: "Total",
        cardStyle: cardStyleStat,
        avatar: displayAvatar('#264653',
          <CenterFocusStrongIcon />),
      });
    }
    return ([...extraStatCard, ...useCasesDuration, ...useCasesCount]);
  } else {
    let tempWholeDataStatCardCount = [...wholeData];
    tempWholeDataStatCardCount = tempWholeDataStatCardCount.filter((data) => statCardsCountEvents.includes(data.incidentType));
    const totalIncidentCountsTemp = calculateTotalIncidentCounts(tempWholeDataStatCardCount);
    const useCasesCount = statCardsCountEvents.map((countEvent, index) => {
      const tempCount = totalIncidentCountsTemp.find(f => f.incidentTypes === countEvent);
      return {
        title: countEvent,
        body: tempCount ? tempCount.incidentCount.toString() : '0', //useCase.incidentCount.toString(),
        footer: "Total",
        cardStyle: cardStyleStat,
        avatar: displayAvatar(getEventTypeColor(countEvent, applicationConfig),
          <CenterFocusStrongIcon />),
      }
    });

    let tempWholeDataStatCardDuration = [...wholeData];
    tempWholeDataStatCardDuration = tempWholeDataStatCardDuration.filter((data) => statCardsDurationEvents.includes(data.incidentType));
    const totalIncidentDurationTemp = calculateTotalIncidentDuration(tempWholeDataStatCardDuration)
    const useCasesDuration = statCardsDurationEvents.map((durationEvent, index) => {
      const tempDuration = totalIncidentDurationTemp.find(f => f.incidentTypes === durationEvent);
      return {
        title: durationStatcardMapping[durationEvent] || durationEvent,
        body: tempDuration ? tempDuration.incidentCount : '00:00:00', //useCase.incidentCount.toString(),
        footer: "Total Duration",
        cardStyle: cardStyleStat,
        avatar: displayAvatar(getEventTypeColor(durationEvent, applicationConfig),
          <CenterFocusStrongIcon />),
      }
    });

    const extraStatCard = [];
    if (applicationConfig === 'DashboardManufacturingBundleDMS-Safety') {
      const totalCount = wholeData.filter(f => statCardsDurationEvents.includes(f.incidentType) ||
        statCardsCountEvents.includes(f.incidentType)).length;
      extraStatCard.push({
        title: 'Total Events',
        body: totalCount,
        footer: "Total",
        cardStyle: cardStyleStat,
        avatar: displayAvatar('#264653',
          <CenterFocusStrongIcon />),
      });
    } else if (applicationConfig === 'DashboardManufacturingBundleDomtar-Gantry') {
      const totalCount = wholeData
        .filter(f => f.incidentType === 'Wet-end Crane Violation Started' ||
          f.incidentType === 'Dry-end Crane Violation Started' ||
          f.incidentType === 'Gantry Exiting Safe Zone').length;
      extraStatCard.push({
        title: 'Total Events',
        body: totalCount,
        footer: "Total",
        cardStyle: cardStyleStat,
        avatar: displayAvatar('#264653',
          <CenterFocusStrongIcon />),
      });
    }

    return ([...extraStatCard, ...useCasesDuration, ...useCasesCount]);
  }

}

export const generatePieChartData = (
  wholeData,
  pieChartEvents,
  applicationConfig
) => {
  let pieChartData = {
    chartData: [],
    chartColors: null
  };
  let tempWholeDataPieChart = [...wholeData];
  tempWholeDataPieChart = tempWholeDataPieChart.filter((data) => pieChartEvents.includes(data.incidentType));
  // console.log('temp whole data pie chart: ', tempWholeDataPieChart);
  const totalIncidentCountsPiChartTemp = calculateTotalIncidentCounts(tempWholeDataPieChart)

  // Update pie chart
  let pieData = [
    ["Events", "Count"]
  ];
  let tempPiechartColors = [];
  totalIncidentCountsPiChartTemp
    .forEach(eventType => {
      pieData.push([eventType.incidentTypes, eventType.incidentCount]);
      if (getEventTypeColor(eventType.incidentTypes, applicationConfig)) {
        tempPiechartColors.push(getEventTypeColor(eventType.incidentTypes, applicationConfig));
      }
    })
  if (pieData.length > 1) {
    pieChartData.chartData = pieData;
  }
  if (tempPiechartColors.length) {
    pieChartData.chartColors = tempPiechartColors;
  }
  return pieChartData
}

const columns = [
  { type: "string", id: "Camera" },
  { type: "string", id: "dummy bar label" },
  { type: "string", role: "tooltip", 'p': { 'html': true } },
  { type: 'string', id: 'style', role: 'style' },
  { type: "datetime", id: "Start" },
  { type: "datetime", id: "End" },
];

export const generateTimelineData = (
  wholeData,
  timeLineEvents,
  cameraData,
  applicationConfig
) => {
  let tempWholeDataTimeline = [...wholeData];
  tempWholeDataTimeline = tempWholeDataTimeline.filter((data) => timeLineEvents.includes(data.incidentType));
  const tempTimelineData = [columns, ...tempWholeDataTimeline
    .map((d) => {
      // Create start and end time based on whether the event is an "Ended" event
      let startTime = d.incidentType.includes("Ended") ? d.incidentTime - d.incidentDuration : d.incidentTime;
      let endTime = d.incidentType.includes("Ended") ? d.incidentTime : d.incidentTime + d.incidentDuration;

      // Show notification if video is not available
      let displayPopup = d.video === "" ?
        `<div style="padding: 5px; width: 300px">` +
        `Event Type: ${d.incidentType}` +
        `<br/>` +
        `Event Started: ${getDisplayFullDateShort(new Date(startTime))}` +
        `<br/>` +
        `Event Ended: ${getDisplayFullDateShort(new Date(endTime))} ` +
        `<br/>` +
        `Duration: ${msToTime(d.incidentDuration)}` +
        `<br/>Event Replay not available for this event<br/>` +
        `</div>`
        :
        `<div style="padding: 5px; width: 300px">` +
        `Event Type: ${d.incidentType}` +
        `<br/>` +
        `Event Started: ${getDisplayFullDateShort(new Date(startTime))}` +
        `<br/>` +
        `Event Ended: ${getDisplayFullDateShort(new Date(endTime))} ` +
        `<br/>` +
        `Duration: ${msToTime(d.incidentDuration)}` +
        `<br/>` +
        `</div>`;

      return ([
        getCameraName(d.cameraId, cameraData),
        '',
        displayPopup,
        getEventTypeColor(d.incidentType, applicationConfig),
        new Date(startTime),
        new Date(endTime),
      ]);
    })];

  if (tempTimelineData.length > 1) {
    return tempTimelineData
  } else {
    return []
  }
}

export const generateVideoDataAnalyticsListing = (
  wholeData,
  timeLineEvents,
  cameraData,
  locationsData
) => {
  let tempWholeDataTimeline = [...wholeData];
  tempWholeDataTimeline = tempWholeDataTimeline.filter((data) => timeLineEvents
    .includes(data.incidentType));

  return tempWholeDataTimeline
    .map(d => {
      return ({
        ...d,
        incidentCamera: getCameraName(d.cameraId, cameraData),
        incidentLocation: getLocationName(d.locationId, locationsData)
      })
    });
}

export const generateEventReplyDatagridData = (
  wholeData = [],
  locationSelected = '',
  cameraSelected = '',
  apiCallAllEvents = [],
  selectedIncidents = [],
  eventReplayPageEvents = [],
) => {
  let tempWholeData = [...wholeData];
  // sort by incident time descending
  tempWholeData = tempWholeData.sort((a, b) => {
    return b.incidentTime - a.incidentTime;
  });

  // filter all data by selected location
  if (locationSelected) {
    tempWholeData = tempWholeData.filter(d => d.locationId === locationSelected);
  }

  // filter all data by selected camera
  if (cameraSelected) {
    tempWholeData = tempWholeData.filter(d => d.cameraId === cameraSelected);
  }

  // filter all data by all available incidents
  if (apiCallAllEvents && apiCallAllEvents.length > 0) {
    tempWholeData = tempWholeData.filter((data) => apiCallAllEvents.includes(data.incidentType));
  }

  // filter all data by selected incidents
  if (selectedIncidents && selectedIncidents.length) {
    tempWholeData = tempWholeData.filter((data) => selectedIncidents.includes(data.incidentType));
  }

  // filter all data by relevant events
  if (eventReplayPageEvents && eventReplayPageEvents.length) {
    tempWholeData = tempWholeData.filter((data) => eventReplayPageEvents.includes(data.incidentType));
  }

  return tempWholeData.map((d, index) => { return ({ ...d, id: index }) });
}

export const checkValidLogin = () => {
  let currTime = new Date().getTime();
  let user = store.get("user");
  let sessionExpiry = user && user.sessionExpiry ? user.sessionExpiry : 0;
  const authToken = store.get("authToken");
  if (!user ||
    (sessionExpiry !== 0 && currTime > sessionExpiry) ||
    !authToken || authToken === "") {
    return false;
  }
  return true;
}
